import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlertCircle, ShieldCheck } from "lucide-react";

/**
 * PAPER vs LIVE environment badge — reads /api/config/features.
 * Renders red LIVE badge when both live_trading_master AND live_trading are on;
 * green PAPER badge otherwise.
 */
export default function EnvBadge() {
  const [flags, setFlags] = useState(null);

  useEffect(() => {
    api.get("/config/features")
      .then(({ data }) => setFlags(data.flags))
      .catch(() => setFlags({}));
  }, []);

  if (!flags) return null;
  const isLive = Boolean(flags.can_route_live_orders);
  const Icon = isLive ? AlertCircle : ShieldCheck;
  return (
    <span
      data-testid={isLive ? "env-badge-live" : "env-badge-paper"}
      title={isLive ? "LIVE trading enabled — real money" : "Paper trading only — simulated cash"}
      className={`inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.1em] px-2 py-1 rounded-full border ${
        isLive
          ? "bg-red-50 text-red-700 border-red-200"
          : "bg-green-50 text-green-700 border-green-200"
      }`}
    >
      <Icon size={11} />
      {isLive ? "Live" : "Paper"}
    </span>
  );
}
